"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-top: ", ";\n  width: ", ";\n  transform: translateX(-1px);\n  margin: 0 auto;\n  height: ", ";\n  max-width: ", ";\n  z-index: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: ", ";\n  ", "\n  background: black;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerOuter = exports.PlayerContainer = exports.Player = void 0;

var react_1 = __importDefault(require("react"));

var useResizeObserver_1 = require("../dom/useResizeObserver");

var isNative_1 = require("../isNative");

var styled_1 = require("../styled");

var AudioOverlay_1 = require("./AudioOverlay");

var EventsContainer_1 = require("./EventsContainer");

var MediaPlaybackContext_1 = require("./MediaPlaybackContext");

var PlayerFooter_1 = require("./PlayerFooter");

var PlayerFooterContainer_1 = require("./PlayerFooterContainer");

var PlayerWrapper_1 = require("./PlayerWrapper");

var COMPACT_SIZE_WIDTH = 400;
var ULTRA_COMPACT_SIZE_WIDTH = 300;

function useFooterKey(fullscreen) {
  var _react_1$default$useS = react_1.default.useState(0),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      footerKey = _react_1$default$useS2[0],
      setFooterKey = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    setFooterKey(function (k) {
      return k + 1;
    });
  }, [fullscreen]);
  return footerKey;
}

var noop = function noop() {};
/**
 * Hook for binding event listeners to the player.
 */


function useEvent(event, ref) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
  react_1.default.useEffect(function () {
    if (!ref.current) return;
    var el = ref.current;
    el.addEventListener(event, callback);
    return function () {
      return el.removeEventListener(event, callback);
    };
  }, [callback, event, ref]);
}

function InnerPlayer(_ref) {
  var children = _ref.children,
      propPlayerRef = _ref.playerRef,
      forceFooter = _ref.forceFooter,
      footerProps = _ref.footerProps,
      useAudioOverlay = _ref.useAudioOverlay,
      fill = _ref.fill;

  var _ref2 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      playerRef = _ref2.playerRef,
      setDuration = _ref2.setDuration,
      setProgress = _ref2.setProgress,
      setIsBuffering = _ref2.setIsBuffering,
      onSetPlaying = _ref2.onSetPlaying,
      onSeek = _ref2.onSeek,
      isPlaying = _ref2.isPlaying,
      setOnSeek = _ref2.setOnSeek,
      playbackSpeed = _ref2.playbackSpeed,
      volume = _ref2.volume,
      fullscreen = _ref2.fullscreen;

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      _footerVisible = _react_1$default$useS4[0],
      setFooterVisible = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(false),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      overFooter = _react_1$default$useS6[0],
      setOverFooter = _react_1$default$useS6[1];

  var _react_1$default$useS7 = react_1.default.useState(isPlaying),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      playingTimeoutVisible = _react_1$default$useS8[0],
      setPlayingTimeoutVisible = _react_1$default$useS8[1];

  react_1.default.useEffect(function () {
    if (isPlaying) {
      setPlayingTimeoutVisible(true);
      var timeout = setTimeout(function () {
        setPlayingTimeoutVisible(false);
      }, 3000);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [isPlaying]);
  var footerVisible = _footerVisible || overFooter || playingTimeoutVisible;
  var containerRef = react_1.default.useRef();

  var _ref3 = (0, useResizeObserver_1.useResizeObserver)({
    ref: containerRef
  }),
      width = _ref3.width;

  var compactMode = undefined;

  if (!isNative_1.isNative && !!width && width > 0 && width < COMPACT_SIZE_WIDTH) {
    compactMode = PlayerFooter_1.PlayerFooterCompactMode.Compact;
  } else if (!!width && width > 0 && width < ULTRA_COMPACT_SIZE_WIDTH) {
    compactMode = PlayerFooter_1.PlayerFooterCompactMode.UltraCompact;
  } // if (isPlaying && compactMode === PlayerFooterCompactMode.UltraCompact) {
  //   footerVisible = false
  // }
  // This is to make sure we re-render the footer whenever fullscreen is changed
  // so the tools show with the proper container.


  var footerKey = useFooterKey(fullscreen);
  react_1.default.useLayoutEffect(function () {
    var _a;

    if ((_a = playerRef.current) === null || _a === void 0 ? void 0 : _a.pause) {
      if (isPlaying && playerRef.current.paused) {
        playerRef.current.play();
      } else if (!isPlaying && !playerRef.current.paused) {
        playerRef.current.pause();
      }
    }
  }, [isPlaying]);
  react_1.default.useEffect(function () {
    var _a;

    if ((_a = playerRef.current) === null || _a === void 0 ? void 0 : _a.playbackRate) {
      playerRef.current.playbackRate = playbackSpeed;
    }
  }, [playbackSpeed]);
  react_1.default.useEffect(function () {
    if (playerRef.current) {
      playerRef.current.volume = volume;
    }
  }, [volume]);
  react_1.default.useEffect(function () {
    setOnSeek(function (seconds) {
      if (playerRef.current) {
        playerRef.current.currentTime = seconds;
      }
    });
  }, []);
  var events = react_1.default.useMemo(function () {
    return {
      durationChange: function durationChange(e) {
        var d = e.timeStamp;

        if (playerRef.current && playerRef.current.duration && playerRef.current.duration < Infinity && playerRef.current.duration > -Infinity) {
          d = playerRef.current.duration;
        }

        if (d && d < Infinity && d > -Infinity) {
          setDuration(d);
        }
      },
      updateProgress: function updateProgress() {
        if (playerRef.current) {
          var loadedSeconds = playerRef.current.buffered.length ? playerRef.current.buffered.end(playerRef.current.buffered.length - 1) : 0;
          var playedSeconds = playerRef.current.currentTime;
          var duration = !isNaN(playerRef.current.duration) && isFinite(playerRef.current.duration) ? playerRef.current.duration : 0;
          setProgress({
            loaded: duration ? loadedSeconds / duration : 0,
            loadedSeconds: loadedSeconds,
            played: duration ? playedSeconds / duration : 0,
            playedSeconds: playedSeconds
          });
        }
      },
      waiting: function waiting() {
        setIsBuffering(true);
      },
      playing: function playing() {
        setIsBuffering(false);
      },
      play: function play() {
        onSetPlaying(true);
        setIsBuffering(false);
      },
      ended: function ended() {
        onSetPlaying(false);
        onSeek(0);
      }
    };
  }, []);
  useEvent('durationchange', playerRef, events.durationChange);
  useEvent('timeupdate', playerRef, events.updateProgress);
  useEvent('progress', playerRef, events.updateProgress);
  useEvent('waiting', playerRef, events.waiting);
  useEvent('canplay', playerRef, events.playing);
  useEvent('playing', playerRef, events.playing);
  useEvent('play', playerRef, events.play);
  useEvent('ended', playerRef, events.ended);
  return react_1.default.createElement(PlayerWrapper_1.PlayerWrapper, {
    containerRef: containerRef
  }, react_1.default.createElement(exports.PlayerContainer, {
    fullscreen: fullscreen,
    ref: containerRef,
    className: 'player-container',
    fill: !!fill
  }, react_1.default.createElement(exports.PlayerOuter, {
    fullscreen: fullscreen,
    isAudio: !!useAudioOverlay,
    className: 'player-outer',
    fill: !!fill
  }, useAudioOverlay ? react_1.default.createElement(AudioOverlay_1.AudioOverlay, {
    isCompact: compactMode !== undefined
  }) : null, react_1.default.cloneElement(children, {
    ref: function ref(c) {
      playerRef.current = c;

      if (propPlayerRef) {
        propPlayerRef.current = c;
      }
    },
    className: "player ".concat(children.props.className),
    style: Object.assign(Object.assign(Object.assign({}, children.props.style), PlayerInnerStyles), {
      width: '100%',
      height: '100%',
      display: isNative_1.isNative ? undefined : 'block'
    })
  })), react_1.default.createElement(EventsContainer_1.EventsContainer, {
    footerVisible: useAudioOverlay ? true : isPlaying && !forceFooter ? !!footerVisible : true,
    setFooterVisible: setFooterVisible,
    setOverFooter: setOverFooter
  }), react_1.default.createElement(PlayerFooterContainer_1.FooterContainer, {
    className: 'footer',
    footerVisible: useAudioOverlay ? true : isPlaying && !forceFooter ? !!footerVisible : true,
    isAudio: !!useAudioOverlay
  }, react_1.default.createElement(PlayerWrapper_1.FooterWrapper, {
    setOverFooter: setOverFooter
  }, react_1.default.createElement(PlayerFooter_1.PlayerFooter, Object.assign({}, footerProps, {
    key: footerKey,
    compact: compactMode,
    hideFullscreen: (footerProps === null || footerProps === void 0 ? void 0 : footerProps.hideFullscreen) || fill,
    visible: useAudioOverlay ? true : isPlaying && !forceFooter ? !!footerVisible : true
  }))))));
}

function Player(_a) {
  var children = _a.children,
      playerRef = _a.playerRef,
      forceFooter = _a.forceFooter,
      footerProps = _a.footerProps,
      useAudioOverlay = _a.useAudioOverlay,
      fill = _a.fill,
      providerProps = __rest(_a, ["children", "playerRef", "forceFooter", "footerProps", "useAudioOverlay", "fill"]);

  var playerProps = {
    children: children,
    playerRef: playerRef,
    forceFooter: forceFooter,
    footerProps: footerProps,
    useAudioOverlay: useAudioOverlay,
    fill: fill
  };

  if (providerProps.noContext) {
    return react_1.default.createElement(InnerPlayer, Object.assign({}, playerProps));
  } else {
    return react_1.default.createElement(MediaPlaybackContext_1.MediaPlaybackContextProvider, Object.assign({}, providerProps), react_1.default.createElement(InnerPlayer, Object.assign({}, playerProps)));
  }
}

exports.Player = Player;
exports.PlayerContainer = (0, styled_1.styledContainer)(_templateObject(), function (props) {
  return props.fullscreen && !isNative_1.isIOS || props.fill ? '100%' : 'auto';
}, function (props) {
  return props.fill ? 'flex: 1;' : '';
});
exports.PlayerOuter = (0, styled_1.styledContainer)(_templateObject2(), function (props) {
  return props.fill ? '0' : isNative_1.isNative ? '56.25%' : props.isAudio ? 'calc(max(100px, min(20%, 100vh)))' : 'calc(min(56.25%, 100vh))';
}, isNative_1.isNative ? '100%' : 'calc(100% + 2px)', function (props) {
  return props.fullscreen && !isNative_1.isIOS || props.fill ? '100%' : 'auto';
}, isNative_1.isNative ? '10000px' : 'calc(100vh * (16 / 9))');
var PlayerInnerStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 1
};